'use strict';
angular.module('pulianiBookStoreApp')
  .controller('bulkOrderCtrl', function ($scope,bulkorder,toaster,$rootScope,$stateParams) {
$rootScope.title='bulk enquiry';
//if bulk enquiry has book name in the url
if($stateParams.bookName !== '') {
	$scope.user = {
		user_name: $stateParams.bookName
	}
   $scope.contactSave=function() {
      bulkorder.contactSave($scope.user).then(function(data)
       {
        $scope.user = {};
        toaster.pop("info","successfully submitted");
	    console.log("Contact");
        console.log(data);
      })
    }
}
//if not book name in the url
else {
   $scope.contactSave=function() {
   bulkorder.contactSave($scope.user).then(function(data)
     {
        $scope.user = {};
        toaster.pop("info","successfully submitted");
	    console.log("Contact");
        console.log(data);
     })
   }
}


});

